import React, { useEffect, useMemo } from 'react'
import { ModeratorViewListedItemDetailsComponent } from './moderator-view-listed-item-details-component'
import { useModeratorViewListedItemDetailsPage } from './moderator-view-listed-item-details-page.hooks'
import { useModeratorViewListedItemDetailsComponentStyles } from './moderator-view-listed-item-details-page.styles'
import { Card, LinearProgress } from '@material-ui/core'
import { PageWrapper } from '../../components/page-wrapper'
import { BreadcrumbItem } from '../../components/breadcrumbs'
import { useTranslation } from 'react-i18next'

export const ModeratorViewListedItemDetailsPage: React.FC = () => {
  const classes = useModeratorViewListedItemDetailsComponentStyles()
  const { t } = useTranslation()
  const {
    detailProps,
    getModeratorViewListedItemDetails,
    loading,
    deliveryType,
    setInStoreDeliveryType,
  } = useModeratorViewListedItemDetailsPage()

  //Get Item Detail
  useEffect(() => {
    getModeratorViewListedItemDetails(<></>)
  }, [])

  const breadcrumbItems: BreadcrumbItem[] = useMemo(() => {
    const searchCrumb = { label: t('header.menu.search'), to: '/search' as const }
    const moderationCrumb = {
      label: t('header.menu.moderation'),
      to: '/moderation' as const,
    }

    if (!detailProps) {
      if (!loading) return []
      return [searchCrumb, moderationCrumb, { label: '...' }]
    }

    return [
      searchCrumb,
      moderationCrumb,
      { label: detailProps.name?.trim() || (loading ? '...' : '-') },
    ]
  }, [detailProps, loading, t])

  return (
    <div className={classes.pageSurface}>
      {loading && <LinearProgress />}
      <PageWrapper
        title=""
        displayGoBackButton={true}
        goBackNavPath="/moderation"
        breadcrumbItems={breadcrumbItems}
      >
        <Card elevation={0}>
          <div className={classes.mainHolder}>
            {/*@ts-ignore*/}
            <ModeratorViewListedItemDetailsComponent
              {...detailProps}
              loading={loading}
              deliveryType={deliveryType}
              setInStoreDeliveryType={setInStoreDeliveryType}
            />
          </div>
        </Card>
      </PageWrapper>
    </div>
  )
}
